let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eVo2q")).then(() => parcelRequire('4G3Sl'));